/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The level of verification of a smart contract, as defined by Sourcify.
 * An absence of this field means that the contract has not been verified.
 * See also https://docs.sourcify.dev/docs/full-vs-partial-match/
 * @export
 * @enum {string}
 */
export enum VerificationLevel {
    Partial = 'partial',
    Full = 'full'
}

export function VerificationLevelFromJSON(json: any): VerificationLevel {
    return VerificationLevelFromJSONTyped(json, false);
}

export function VerificationLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerificationLevel {
    return json as VerificationLevel;
}

export function VerificationLevelToJSON(value?: VerificationLevel | null): any {
    return value as any;
}

